module.exports = __webpack_public_path__ + "2020celebration/img/family-l.89bd83a9.png";